<template lang="html">
  <td class="table-action-cell text-xs-right">
    <v-menu
      offset-y
      content-class="dropdown-menu"
      transition="slide-y-transition">
      <v-btn
        slot="activator"
        color="secondary"
        fab
        small>
        <v-icon>mdi-chevron-down</v-icon>
      </v-btn>
      <v-card>
        <v-list dense>
          <router-link :to="{
              name: 'Edit Trip',
              params: { id: quoteId }
            }">
            <v-list-tile>
              <v-list-tile-title v-text="'Edit'"/>
            </v-list-tile>
          </router-link>
        </v-list>
      </v-card>
    </v-menu>
  </td>
</template>

<script>
export default {
  props: {
    quoteId: {
      required: true,
      type: [Number, String]
    }
  }
}
</script>

<style lang="css" scoped>
</style>
